import React from 'react';
import './AlertModal.less';

/**
 * Componente de alerta modal reutilizable con ícono a la izquierda y contenido a la derecha.
 * Diseño basado en alertas modales profesionales con dos columnas.
 * 
 * @param {Object} props - Propiedades del componente
 * @param {boolean} props.isOpen - Indica si el modal está visible
 * @param {string} props.type - Tipo de alerta: 'success', 'error', 'warning', 'info'
 * @param {string} props.title - Mensaje principal del modal
 * @param {string} [props.message] - Mensaje secundario del modal
 * @param {string} [props.buttonText='Aceptar'] - Texto del botón de acción
 * @param {Function} props.onClose - Callback que se ejecuta al cerrar el modal
 * @param {Function} [props.onButtonClick] - Callback que se ejecuta al hacer clic en el botón
 * 
 * @example
 * <AlertModal
 *   isOpen={showModal}
 *   type="success"
 *   title="Información enviada exitosamente"
 *   message="Te contactaremos pronto"
 *   buttonText="Aceptar"
 *   onClose={() => setShowModal(false)}
 *   onButtonClick={() => resetForm()}
 * />
 */
export const AlertModal = ({
  isOpen,
  type = 'info',
  title,
  message,
  buttonText = 'Aceptar',
  onClose,
  onButtonClick
}) => {
  if (!isOpen) return null;

  const getIconClass = () => {
    switch (type) {
      case 'success':
        return 'fa-check-circle';
      case 'error':
        return 'fa-times';
      case 'warning':
        return 'fa-exclamation-circle';
      case 'info':
        return 'fa-info-circle';
      default:
        return 'fa-check-circle';
    }
  };

  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    }
    onClose();
  };

  return (
    <div className="alert-modal-overlay">
      <div className={`alert-modal alert-modal-${type}`}>  

        <div className="alert-modal-container">
          {/* Columna izquierda: Ícono */}
          <div className="alert-modal-icon-container">
            <i className={`fas ${getIconClass()}`}></i>
          </div>

          {/* Columna derecha: Contenido */}
          <div className="alert-modal-content">
            {title && <h3 className="alert-modal-title">{title}</h3>}

            {message && <p className="alert-modal-message">{message}</p>}

            <button
              className="alert-modal-button"
              onClick={handleButtonClick}
            >
              {buttonText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
